module.exports = __webpack_public_path__ + "static/pressCloseup-ad5ad235c15fa59f88eaf5d0ee9b43be.jpg";